import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useState } from "react";
import { config as appConfig } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { useRefresh } from "@hostingbv/lib/src/components/RefreshController";
import { Site } from "@hostingbv/lib/src/api/partner/models/Site";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const EditSiteNginxConfigModal: FC<{ entity: Site }> = (props) => {
  const { partnerClient } = useApiClient(appConfig)
  const refresh = useRefresh()
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!

  const defaultNginxConfigAvailable = props.entity.server?.defaultNginxConfig !== null && props.entity.server?.defaultNginxConfig.trim() !== ''
  const [includeDefaultConfig, setIncludeDefaultConfig] = useState<boolean>(false)

  const [error, setError] = useState<string>("")
  const [config, setConfig] = useState(props.entity.deploymentDetails?.additionalNginxSettings ?? "")

  const save = async () => {
    const combinedConfig = (includeDefaultConfig ? (props.entity.server?.defaultNginxConfig + "\n\n") : '') + config
    const deployment = await partnerClient.updateSiteNginxConfig(props.entity.id, combinedConfig).then(result => {
      if (!result.success) {
        setError(result.error)
        throw new Error(result.error)
      }
      return result.data
    })
    const updatedDeployment = await awaitNextDeploymentFinished(deployment.id)
    if (updatedDeployment?.status === "failed") {
      // @ts-expect-error output's shape isn't statically typed on Deployment
      setError(updatedDeployment?.output?.message ?? 'Invalid configuration')
      throw new Error('Invalid configuration')
    } else {
      refresh()
    }
  }


  return <>
    <form onSubmit={() => save()} className={""}>
      <div>
        <span className={'text-sm font-medium text-brand-900'}>vhost_nginx.conf</span>
        <div className={'border-2 border-slate-200 rounded-sm mt-1 flex flex-col items-stretch'}>
          {defaultNginxConfigAvailable && <label className={`px-1 mx-1 my-1 group rounded-xs border-2 ${includeDefaultConfig ? 'border-brand-200 bg-brand-50' : 'border-slate-200 hover:border-brand-200 bg-slate-50 hover:bg-brand-50'} cursor-pointer`}>
            <div className={`-mx-1 px-1 py-1 text-xs flex items-center font-medium ${includeDefaultConfig ? 'bg-brand-200 text-brand-900' : 'bg-slate-200 text-slate-900'}`}>
              <input type={'checkbox'} checked={includeDefaultConfig} onChange={() => setIncludeDefaultConfig(!includeDefaultConfig)} className={'mr-1'} />
              <span className={''}>Include default config for this server</span>
            </div>
            <pre className={'font-normal text-slate-600 text-xs py-2 font-mono'}>
              {props.entity.server!.defaultNginxConfig}
            </pre>
          </label>}
          <textarea
            autoFocus={true}
            className={`outline-hidden text-black rounded-sm font-normal px-2 py-2 h-72 text-xs font-mono`}
            placeholder={'location {}'}
            value={config}
            onChange={(e) => setConfig(e.target.value)}
          />
        </div>
        {error !== "" && <div className={"px-3 py-2 bg-red-50 rounded-sm my-4 text-sm text-red-900"}>
          {error}
        </div>}
      </div>
      <ModalFooter text={"Save"} onSubmit={save} />
    </form>
  </>
}
